import { PlusIcon } from '@heroicons/react/16/solid';
import { Box, Button, Modal } from '@platform/ui-library';
import { FC, FormEvent, useState } from 'react';
import { Input, InputFieldType } from '@app/form_components';
import { AppConfigAnchor } from '@app/services/types';
import { useServices } from '../../hooks';

export const CreateAnchor: FC<any> = ({ context }) => {
  const { appConfigService } = useServices();

  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [notes, setNotes] = useState('');

  const selectedAnchorKey = 'bannerAnchor';

  const selectedAnchor = context.getConfig(selectedAnchorKey) || '';

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setIsLoading(true);
    setError('');

    const formProps: Pick<AppConfigAnchor, 'name' | 'notes'> = {
      name,
      notes
    };
    const designId = window.apm.serialized.designId;

    try {
      const response = await appConfigService.createAnchor(designId, formProps);
      changeValue(response.id);
      setName('');
      setNotes('');
      setIsOpen(false);
    } catch (e) {
      setError(e as string);
    }

    setIsLoading(false);
  };

  const changeValue = (newValue: string) => {
    context.setConfig(selectedAnchorKey, newValue);
    const nodeId = context.hasWriteProxy()
      ? context.id
      : context.props.parentComponentID;
    window.apm.updateParentNode(
      context,
      nodeId,
      selectedAnchorKey,
      newValue,
      context.type,
      selectedAnchor
    );
    document.dispatchEvent(new CustomEvent('ev-property-refresh'));
  };

  return (
    <>
      <div className="form-component-container buttonModal">
        <button
          className="form-button square"
          type="button"
          onClick={() => setIsOpen(true)}
        >
          <PlusIcon />
        </button>
        <label>Create new Banner Anchor</label>
      </div>

      {isOpen && (
        <Modal handleClose={() => setIsOpen(false)} isOpen={isOpen}>
          <Box className="buttonModalContent">
            <h3>Create Anchor</h3>
            <form onSubmit={onSubmit}>
              <fieldset disabled={isLoading}>
                <Input
                  label="Name"
                  name="name"
                  onChange={setName}
                  placeholder="Anchor Name"
                  value={name}
                />
                <Input
                  label="Notes"
                  name="notes"
                  onChange={setNotes}
                  placeholder="Additional Notes"
                  rows={3}
                  type={InputFieldType.textarea}
                  value={notes}
                />
              </fieldset>

              {error && <div className="form-errors">{error}</div>}

              <div className="buttonModalContent-actions">
                <fieldset disabled={isLoading}>
                  <Button
                    type="button"
                    onClick={() => setIsOpen(false)}
                    theme="outline"
                    disabled={isLoading}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" disabled={isLoading}>Submit</Button>
                </fieldset>
              </div>
            </form>
          </Box>
        </Modal>
      )}
    </>
  );
};
